import axios from 'axios'

declare global {
  interface Window {
    sidenav: {
      isAuthenticationComplete: boolean
      getAccessTokenSilentlyOrLogout: () => string
    }
  }
}

const reqInterceptor = async (config: any) => {
  try {
    // eslint-disable-next-line @typescript-eslint/await-thenable
    const token = await window.sidenav.getAccessTokenSilentlyOrLogout()
    if (token) {
      config = {
        ...config,
        headers: { ...config.headers, Authorization: 'Bearer ' + token },
      }
    }
    return config
  } catch (e: any) {
    console.log('Error fetching token from sidebar export function')
    throw e
  }
}

/*
Update baseURL to https://performance-ws.uswe2.beta.aws.cwan.io from
process.env variables
 */
const axiosInstance = axios.create({
  // baseURL: 'https://localhost', //process.env.API_GATEWAY_URL
  baseURL: realmConfig.axiomReportsApi, //process.env.API_GATEWAY_URL
})

// Request interceptor for adding the bearer token
const cy = window['Cypress' as any]
if (!cy) {
  axiosInstance.interceptors.request.use(reqInterceptor, (error) => {
    return Promise.reject(error)
  })
}

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    throw err //updated to get raw error message from axios/api
  },
)

export default axiosInstance
